import { gql } from '@apollo/client'

export const shuffleDailyAction = gql`
  mutation ShuffleDailyAction($action: String!) {
    shuffleDailyAction(action: $action)
  }
`
